(ns hypnos.consumer.subs
  "Subscriptions for the consumer application."
  (:require [re-frame.core :as rf]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; General

(rf/reg-sub
 :consumer/subdomain
 (fn [db _]
   (get-in db [:subdomain])))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; UI

(rf/reg-sub
 :consumer/active-panel
 (fn [db _]
   (get-in db [:ui :active-panel])))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Consult

(rf/reg-sub
 :consumer/consult
 (fn [db _]
   (get-in db [:consult])))

(rf/reg-sub
 :consumer/portrait-upload-status
 (fn [db _]
   (get-in db [:portrait :upload-status])))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Error

(rf/reg-sub
 :consumer/error
 (fn [db _]
   (get-in db [:error])))
